import React from 'react';
import './progressBar.scss';

class ProgressBar extends React.Component {
    render() {
        return (
            <>
                <progress className={this.props.site} value={`${this.props.progress}`} max="100"></progress>
            </>
        )
    }

}

export default ProgressBar;